import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PlanningService } from '../../providers/planning.service';
import { IPlanningUser, IPlanning } from '../../../typings/timetracker/timetracker';
import { Observable } from 'rxjs/Observable';
import { InviteUsersDialogComponent } from '../../components/invite-users-dialog/invite-users-dialog';
import { MatDialog } from '@angular/material';
import { TimeTrackerBaseApi } from '../../providers/generic.service';
import { IActivityDuringPlanningResponse } from '../../../typings/api';
import * as moment from 'moment';
import { size } from 'lodash';

/**
 * Generated class for the PlanningDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-planning-details',
  templateUrl: 'planning-details.html',
})
export class PlanningDetailsPage {

  public users$: Observable<IPlanningUser[]>;
  public activities$: Observable<IActivityDuringPlanningResponse[]>;
  public details$: Observable<IPlanning>;

  updateTime( time ) {
    this.details$.take( 1 ).subscribe( ( planning ) => {
      this.$planningAPI.dispatchUpdatePlanning( planning.id, planning.year, planning.iso_week, planning.iso_weekday, time )
      .then( () => {
        this.$baseAPI.showToast( 'Planning is bijgewerkt' );
        console.log( '[PLANNING-DETAILS] Planning updated' );
      } )
      .catch( ( error ) => {
        this.$baseAPI.showToast( 'Probleem bij het updaten van de planning' );
        console.error( '[PLANNING-DETAILS] Planning updating error', error );
      });
    } );
  }

  /**
   * Upsert activity to this planning
   * @param {IActivityDuringPlanningResponse} activity The activity to upsert
   */
  updateActivityEndTime( activity: IActivityDuringPlanningResponse, endTime: string ) {

    this.details$.take( 1 ).subscribe( ( planning ) => {

      let theStartMoment  = moment( planning.start_time );;
      let theEndMoment    = theStartMoment.clone();

      // Probably not needed, but maybe in case of old 'not rounded' start times
      //
      theEndMoment.startOf( 'minute' );

      if ( size( endTime ) > 5 ) {
        theEndMoment.hours( moment( endTime ).hours() );
        theEndMoment.minutes( moment( endTime ).minutes() );
      } else {
        const payload = endTime.split( ':' );
        const hours   = parseInt( payload[ 0 ], 10 );
        const minutes = parseInt( payload[ 1 ], 10 );
        theEndMoment  = theStartMoment.hours( hours ).minutes( minutes );
      }

      if (activity.activity_planning_id ) {
        this.$planningAPI.dispatchUpdateActivityInPlanning( {
          id: activity.activity_planning_id,
          activity_id: activity.id,
          planning_id: planning.id,
          end_time: theEndMoment.format(),
          pause_duration: activity.pause_duration,
          created_at: activity.created_at,
          updated_at: activity.updated_at
        } );
        this.$baseAPI.showToast( 'Activiteit eindtijd is gewijzigd' );
        console.log( '[PLANNING-DETAILS] Activitiy end time updated' );
      } else {
        activity.activity_planning_id = undefined;
        this.$planningAPI.dispatchInsertActivityInPlanning({
          activity_id: activity.id,
          planning_id: planning.id,
          end_time: theEndMoment.format(),
          pause_duration: null,
          created_at: activity.created_at,
          updated_at: activity.updated_at
        } );
        this.$baseAPI.showToast( 'Activiteit eindtijd is toegevoegd aan de planning' );
        console.log( '[PLANNING-DETAILS] Acitivity end time added' );
      }
    } );
  }

  /**
   * Upsert activity to this planning
   * @param {IActivityDuringPlanningResponse} activity The activity to upsert
   */
  updateActivityPauseDuration( activity: IActivityDuringPlanningResponse, pauseDuration: string ) {

    this.details$.take( 1 ).subscribe( ( planning ) => {

      if (activity.activity_planning_id ) {
        this.$planningAPI.dispatchUpdateActivityInPlanning( {
          id: activity.activity_planning_id,
          activity_id: activity.id,
          planning_id: planning.id,
          end_time: activity.end_time,
          pause_duration: pauseDuration,
          created_at: activity.created_at,
          updated_at: activity.updated_at
        } );
        this.$baseAPI.showToast( 'Activiteit pauze duur is gewijzigd' );
        console.log( '[PLANNING-DETAILS] Activitiy pause duration updated' );
      } else {
        activity.activity_planning_id = undefined;
        this.$planningAPI.dispatchInsertActivityInPlanning({
          activity_id: activity.id,
          planning_id: planning.id,
          end_time: null,
          pause_duration: pauseDuration,
          created_at: activity.created_at,
          updated_at: activity.updated_at
        } );
        this.$baseAPI.showToast( 'Activiteit pauze duur is toegevoegd aan de planning' );
        console.log( '[PLANNING-DETAILS] Activity pauze duraton added' );
      }
    } );
  }

  inviteUsersDialog() {
    let dialogRef = this.$dialog.open( InviteUsersDialogComponent, {
      minWidth: '490px',
      data: {
        currentUsers$: this.users$,
        currentPlanning$: this.details$ }
    } );

    dialogRef.afterClosed().subscribe( result => {
      console.log( '[PLANNING-DETAILS]', result );
    } );
  }

  getNow() {
    return moment().format();
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private $dialog: MatDialog,
    private $baseAPI: TimeTrackerBaseApi,
    private $planningAPI: PlanningService ) {

      this.$planningAPI.dispatchPlanningFetch( this.navParams.data.id );

      this.users$      = this.$planningAPI.selectPlanningUsersFetch();
      this.activities$ = this.$planningAPI.selectPlanningActivities().map( ( activities ) => {

        if ( activities ) {
          activities.forEach( ( activity ) => {
            if ( activity.end_time ) {
              activity.end_time = moment( activity.end_time ).format();
            }
          } );

          activities.sort( ( a, b ) => {
            if ( a.name < b.name ) {
              return -1;
            }

            if ( a.name > b.name ) {
              return 1;
            }

            return 0;
          } );
        }

        return activities;
      });

      this.details$    = this.$planningAPI.selectPlanningFetch().map( ( details ) => {
        if ( details && details.start_time ) {
          details.start_time = moment( details.start_time ).format();
        }

        return details;
      } );
  }
}



// WEBPACK FOOTER //
// ./src/pages/planning-details/planning-details.ts